//@flow
import type { Shift } from 'types/index'

export const calculateWeekSum = (shifts: Array<Shift>):number => {
  return shifts.reduce((acc, shift)=> acc + shift.e - shift.s - shift.b  , 0)
}



// WEBPACK FOOTER //
// ./src/containers/app/roster/weekPlan/shiftBoard/userRow/localHelpers.js